import {Box, Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';

type BannerInfoProps = {
  Icon: string;
  isMobile: boolean;
  title: string;
  subTitle: string;
};
const BannerInfo = ({Icon, isMobile, title, subTitle}: BannerInfoProps) => {
  return (
    <Box
      ml={{
        xxs: 0,
        md: 0,
      }}
      sx={{
        '@media (min-width: 1024px) and (max-width: 1279px)': {
          marginLeft: '-14px',
        },
      }}
      display={'flex'}
      alignSelf={{xxs: 'flex-start', md: 'center'}}
    >
      <Box mr={{xxs: 3, md: 4}} alignSelf={'flex-start'}>
        <Image
          src={Icon}
          alt="banner-icon"
          width={isMobile ? 45 : 55}
          height={isMobile ? 45 : 55}
        />
      </Box>
      <Box alignSelf="center">
        {!isMobile && (
          <Typography
            color="#ffffff"
            fontSize={{xxs: 12, md: 16}}
            lineHeight={'24px'}
          >
            {title}
          </Typography>
        )}

        <Typography
          color="#ffffff"
          fontSize={{xxs: 16, md: 24}}
          lineHeight={{xxs: '24px', md: '35px'}}
          maxWidth={733}
          fontWeight={{xxs: 700, md: 700}}
        >
          {subTitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default BannerInfo;
